export const paths = ['/accounting-integrations'];
